<template>
  <div class="chosen-filters" v-if='hasSimpleOrComponentFilters'>
    <ul>
      <li v-for='(v, k) in componentFilters' :key='k'>
        <span @click.prevent='currentFilter = queryToFilter(k)'>
          {{ $t('root.filters.checklistItems.' + queryToFilter(k)) }}
          <strong>{{ valueToFilter(k, v) }}</strong>
        </span>

        <span @click.prevent.stop='resetFilter(k)' class="remove-item">x</span>

        <div class="edit-filter" v-show='currentFilter == queryToFilter(k)'>
          <component :is="'filter-items-by-' + queryToFilter(k)" @cancel='closeDropdown' />
          <span @click.prevent.stop='currentFilter = null' class="close-item">x</span>
        </div>
      </li>

      <li v-for='(v, k) in simpleFilters' :key='k'>
        <span>
          {{ $t('root.filters.checklistItems.' + queryToFilter(k)) }}
          <strong>{{ v }}</strong>
        </span>

        <span @click.prevent.stop='resetFilter(k)' class="remove-item">x</span>
      </li>
    </ul>

    <button @click.prevent='resetFilters' class="remove-filters own-tooltip own-tooltip-left" :data-tooltip="$t('root.filters.remove_all_filters')">
      <i class="fas fa-trash"></i>
    </button>
  </div>
</template>

<script>

import _filter_items_by_contact from './_filter_by_contact'
import _filter_items_by_product from './_filter_by_product_id'
import _filter_items_by_document_type from './_filter_by_document_id'
import _filter_items_by_folder from './_filter_by_folder_id'
import _filter_items_by_record from './_filter_by_items_with_record'
import _filter_items_by_shared from './_filter_by_shared'
import _filter_items_by_exp_status from './_filter_by_exp_status'

export default {
  components: {
    'filter-items-by-contact_id_in': _filter_items_by_contact,
    'filter-items-by-contact_id_not_in': _filter_items_by_contact,
    'filter-items-by-product_id_in': _filter_items_by_product,
    'filter-items-by-product_id_not_in': _filter_items_by_product,
    'filter-items-by-document_type_id_in': _filter_items_by_document_type,
    'filter-items-by-document_type_id_not_in': _filter_items_by_document_type,
    'filter-items-by-folder_id_in': _filter_items_by_folder,
    'filter-items-by-folder_id_not_in': _filter_items_by_folder,
    'filter-items-by-record_id_not_null': _filter_items_by_record,
    'filter-items-by-shared_eq': _filter_items_by_shared,
    'filter-items-by-status-in': _filter_items_by_exp_status,
    'filter-items-by-status-not-in': _filter_items_by_exp_status,
  },
  created() {
    this.loadFilterData()
  },
  watch: {
    query() {
      this.currentFilter = null
      this.loadFilterData()
    }
  },
  data() {
    return {
      currentFilter: null,
      contacts: [],
      tags: [],
      products: [],
      documents: [],
      folders: [],
      users: [],
    }
  },
  computed: {
    simpleFilters() {
      const fs = ['filters[content_cont]']
      const res = {}
      fs.forEach(f => {
        if (this.query[f])
          res[f] = this.query[f]
      })
      return res
    },
    componentFilters() {
      const f = {}
      Object.keys(this.query).forEach(k => {
        if (!this.simpleFilters[k] && k.indexOf('filters') >= 0 && k.indexOf('filters[s]') < 0)
          f[k] = this.query[k]
      })
      return f
    },
    hasSimpleOrComponentFilters() {
      return (Object.keys(this.componentFilters).length + Object.keys(this.simpleFilters).length) > 0
    },
    contactIds() {
      return this.query['filters[contact_id_in]'] || this.query['filters[contact_id_not_in]']
    },
    productIds() {
      return this.query['filters[product_id_in]'] || this.query['filters[product_id_not_in]']
    },
    documentIds() {
      return this.query['filters[document_type_id_in]'] || this.query['filters[document_type_id_not_in]']
    },
    folderIds() {
      return this.query['filters[folder_id_in]'] || this.query['filters[folder_id_not_in]']
    },
  },
  methods: {
    queryToFilter(f) {
      return f.replace(/filters\[|\]/g, '')
    },
    valueToFilter(f, v) {
      if (f == 'filters[contact_id_in]' || f == 'filters[contact_id_not_in]')
        return this.intersectAndFormat(this.contacts, v)
      else if (f == 'filters[product_id_in]' || f == 'filters[product_id_not_in]')
        return this.intersectAndFormat(this.products, v)
      else if (f == 'filters[document_type_id_in]' || f == 'filters[document_type_id_not_in]')
        return this.intersectAndFormat(this.documents, v)
      else if (f == 'filters[folder_id_in]' || f == 'filters[folder_id_not_in]')
        return this.intersectAndFormat(this.folders, v)
      else if (f == 'filters[record_status_in]' || f == 'filters[record_status_not_in]')
        return this.formatExpStatus(v)
      else
        return this.$t('root.filters.' + v)
    },
    resetFilter(f) {
      let newQuery = Object.assign({}, this.query)

      delete newQuery[f]

      if (Object.keys(this.componentFilters).length == 1)
        delete newQuery['parent_id']

      this.$router.push({ query: newQuery })
    },
    resetFilters() {
      this.$router.push({ query: {} })
    },
    intersectAndFormat(resources, v) {
      const ids = Array.isArray(v) ? v.map(x => parseInt(x)) : [parseInt(v)]
      return resources.filter(x => ids.indexOf(x.id) >= 0).map(x => x.name).join(', ')
    },
      formatExpStatus(v) {
        const arr = Array.isArray(v) ? v.map(x => this.expStatusTranslations[x]) : [this.expStatusTranslations[v]]
        return arr.join(', ')
      },
    closeDropdown() {
      this.currentFilter = null
    },
    loadFilterData() {
      if (this.contactIds)
        this.listStore.getContacts({ 'filters[id_in]': this.contactIds }).then(({data}) => this.contacts = data)

      if (this.productIds)
        this.listStore.getProducts({ 'filters[id_in]': this.productIds }).then(({data}) => this.products = data)

      if (this.documentIds)
        this.listStore.getDocumentTypes({ 'filters[id_in]': this.documentIds }).then(({data}) => this.documents = data)

      if (this.folderIds)
        this.listStore.getFolders({ 'filters[id_in]': this.folderIds }).then(({data}) => this.folders = data)
    },
  }
}
</script>

<style lang='sass' scoped>
.chosen-filters
  float: left
  width: 100%
  margin: 10px 0
  display: flex
  position: relative
  ul
    margin: 0
    padding: 0
    list-style: none
    display: flex
    flex-wrap: wrap
    li
      border: 1px solid #c6c6c6
      border-radius: 3px
      width: auto
      padding: 3px 5px
      cursor: pointer
      margin-right: 10px
      position: relative
      margin-bottom: 5px
      .remove-item
        font-size: 18px
        padding-left: 10px
  .edit-filter
    position: absolute
    background: #fff
    border: 1px solid #c8c8c8
    top: 40px
    left: 0
    border-radius: 3px
    z-index: 1000
    padding: 10px
    &:after, &:before
      bottom: 100%
      left: 50%
      border: solid transparent
      content: ""
      height: 0
      width: 0
      position: absolute
      pointer-events: none
    &:after
      border-color: rgba(255, 255, 255, 0)
      border-bottom-color: #fff
      border-width: 10px
      margin-left: -10px
    &:before
      border-color: rgba(200, 200, 200, 0)
      border-bottom-color: #c8c8c8
      border-width: 13px
      margin-left: -13px
    .close-item
      position: absolute
      top: -2px
      right: 12px
      font-size: 18px
      cursor: pointer
  .remove-filters
    border: none
    background: #5072ED
    border-radius: 50%
    width: 25px
    height: 25px
    margin-top: 2px
    i
      color: #fff
</style>
